export const messageState = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  IDLE: "IDLE",
  WARNING: "WARNING"
};
export default messageState;
